export type FeatureTrackingLabels = {
    [key: string]: string[]
}

export type ClickTrackingLabels = {
    "wk.promo_AttributionSource": string;
    "wk.promo_AttributionFeature": string;
    promo_ComboType?: string;
}

export type Feature = {
    id: string,
    name: "TopicPromotionLarge",
    position: number,
    status: string,
    labels: FeatureTrackingLabels
}

export type TileFeature = {
    id: string,
    parentId: string,
    name: "TopicPromotionLarge-Tile",
    status: string,
    labels: FeatureTrackingLabels
}

export type MiniActionFeature = {
    featureId: string,
    action: string
}

export const DATA_TRACKED_ATTRIBUTE = "data-tracked";
export const DATA_TRACKED_VALUE = "true";
